import * as React from 'react';

import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

type Props = {
    topRow: string;
    bottomRow: string;
    icon: React.ComponentType<any>;
    onClick: () => void;
};

export function NextStepsCard(props: Props) {
    const Icon = props.icon;

    return (
        <TwoLineButtonCard onClick={props.onClick}>
            <TwoLine
                icon={Icon}
                iconSize={24}
                topRow={props.topRow}
                bottomRow={props.bottomRow}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
        </TwoLineButtonCard>
    );
}
